import { queryOptions, useQuery } from '@tanstack/react-query'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

export interface UseGetDocumentArgs {
  documentId: string
}

export const getDocumentQueryOptions = (args: UseGetDocumentArgs) =>
  queryOptions({
    queryKey: ['documents', args.documentId],
    queryFn: () =>
      apiClient.documents[':documentId']
        .$get({ param: { documentId: args.documentId } })
        .then((r) => formatClientResponse(r)),
  })

export const useGetDocument = (
  args: UseGetDocumentArgs,
  options?: Partial<ReturnType<typeof getDocumentQueryOptions>>
) =>
  useQuery({
    ...getDocumentQueryOptions(args),
    ...options,
  })
